import { type Atom, atom } from "jotai";
import { atomFamily } from "jotai-family";
import { isEqual } from "lodash-es";
import { debugLabel } from "../../generate/store";
import {
  type Library,
  type LibraryQuery,
  type LibraryTemplate,
  isDiscoverTemplateQuery,
} from "./types";

// Null = not attempted; False = failed to load
export const atlasV2LibraryAtom = atom<Library | false | null>(null);

export const libraryAtom = debugLabel(
  `libraryAtom`,
  atom((get) => {
    const library = get(atlasV2LibraryAtom);
    if (library === null || !library) return { programs: [] };
    return library;
  }),
);

export const libraryQueryAtom = atom<LibraryQuery | null>(null);

/**
 * the current library template (as per libraryQueryAtom), hydrated
 */
export const libraryTemplateAtom = debugLabel(
  `libraryTemplateAtom`,
  atom<LibraryTemplate | null>((get) => {
    const templateQuery = get(libraryQueryAtom);
    return templateQuery === null ? null : get(libraryTemplateFamily(templateQuery));
  }),
);

/**
 * a specific library template, hydrated
 */

export const libraryTemplateFamily = atomFamily<LibraryQuery, Atom<LibraryTemplate | null>>(
  (libraryQuery: LibraryQuery) => {
    return debugLabel(
      `libraryTemplateFamily/${JSON.stringify(libraryQuery)}`,
      atom((get) => {
        const { programs } = get(libraryAtom);

        if (isDiscoverTemplateQuery(libraryQuery)) {
          return (
            programs
              .find((p) => p.slug === libraryQuery.program_slug)
              ?.templates.find((t) => t.slug === libraryQuery.template_slug) ?? null
          );
        }

        return null;
      }),
    );
  },
  isEqual,
);
